import React from 'react'

const Icon = ({
  color   = '#e5e5e5',
  type    = ''  
}) => {
  if ( type !== 'count' ) {
    return(
      <span className="circle countIcon filled" style={ { backgroundColor : color } } />
    ) 
  }
  return(
    <span className="icon-font countIcon" style={ { color : color } } dangerouslySetInnerHTML={ { __html: '<' } }/>
  )
}

const Icons = ({
  color   = '',
  total   = 0,
  won     = 0,
  type    = ''
}) => {
        
  let filledCircles  = []
  let emptyCircles  = []
  
  for ( let i = 0; i < won; i++ ) {
    filledCircles.push(
      <Icon key={'cl.'+i} color={color} type={type} />
    )
  }
     
  if ( type !== 'count' ) {
    let remain = total-won
    if ( remain < 0 ) {
      remain = 0
    }
    for ( let i = 0; i < remain; i++ ) {
      emptyCircles.push(
        <Icon key={'cw.'+i} />
      )
    }  
  }
  return (
    <div className="countIcons">
      {filledCircles.concat(emptyCircles)}
    </div>
  )

}

const Lable = ({
  type    = '',
  won     = 0,
  total   = 0,
  homeAway  = 'home'
}) => {
  const percent = parseInt((parseInt(won)/parseInt(total)) * 100)
  
  if ( type !== 'count' ) {
    if ( homeAway === 'home' ) {
      return (
        <div className="countLabel">
          {(won) + '/' + total} <span className="percentage">{'(' + percent + '%)'}</span>
        </div>
      )
    }else{
      return (
        <div className="countLabel">
          <span className="percentage">{'(' + percent + '%)'}</span>{' ' + (won) + '/' + total}
        </div>
      )
    }
  }else{
    return (
      <div className="countLabel">
        {won}
      </div>
    )
  }
}

const VisIcons = ({
  homeColor   = '',
  awayColor   = '',
  homeTotal   = 0,
  awayTotal   = 0,
  homeWon     = 0,
  awayWon     = 0,
  type      = ''
}) => {
  
  return(
    <div className="countChart">
      <div className="home">
        <Lable won={homeWon} total={homeTotal} homwAway="home" type={type} />
        <Icons type={type} color={homeColor} won={homeWon} total={homeTotal} />
      </div>      
      <div className="away">
        <Lable won={awayWon} total={awayTotal} homwAway="away" type={type} />
        <Icons type={type} color={awayColor} won={awayWon} total={awayTotal} />
      </div>
    </div>
  )
} 

export default VisIcons



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/rugby/components/statistics/VisIcons.jsx
 **/